import { render, staticRenderFns } from "./PageFour.vue?vue&type=template&id=45cd8c27&scoped=true&"
import script from "./PageFour.vue?vue&type=script&lang=js&"
export * from "./PageFour.vue?vue&type=script&lang=js&"
import style0 from "./PageFour.vue?vue&type=style&index=0&id=45cd8c27&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cd8c27",
  null
  
)

export default component.exports